import React, { useState } from 'react';

const ImageCard = ({ image, onView, getHost }) => {
  const [isHovered, setIsHovered] = useState(false);

  const handleView = () => {
    onView(image.qr);
  };

  const cardStyle = {
    backgroundColor: "#ffffff",
    border: "1px solid #e0e0e0",
    borderRadius: "12px",
    transition: "all 0.3s ease",
    transform: isHovered ? "translateY(-5px)" : "translateY(0)",
    boxShadow: isHovered ? "0 8px 25px rgba(0,0,0,0.15)" : "0 2px 10px rgba(0,0,0,0.1)"
  };

  const buttonStyle = {
    width: "35px",
    height: "35px",
    borderRadius: "8px",
    border: "none",
    fontSize: "14px",
    fontWeight: "bold",
    cursor: "pointer",
    transition: "all 0.2s ease",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    margin: "2px 0"
  };

  return (
    <div className="col-12 col-sm-6 col-lg-4 mb-4">
      <div 
        className="card h-100"
        style={cardStyle}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <div className="position-relative" style={{ height: "220px", overflow: "hidden", borderRadius: "12px 12px 0 0" }}>
          <img
            src={image.qr.replace('http://127.0.0.1/', getHost() + '/')}
            className="w-100 h-100"
            alt="QR Code Image"
            style={{
              objectFit: "contain",
              cursor: "pointer",
              transition: "transform 0.3s ease",
              transform: isHovered ? "scale(1.05)" : "scale(1)",
              backgroundColor: "#f8f9fa"
            }}
            onClick={handleView}
          />
          

        </div>
        
        <div className="card-body text-center" style={{ padding: "20px" }}>
          <h6 className="card-title mb-2" style={{ color: "#495057", fontWeight: "600", fontSize: "14px" }}>
            QR Code Image
          </h6>
          <p className="card-text mb-2" style={{ fontSize: "12px", color: "#6c757d" }}>
            {image.qr ? image.qr.split('/').pop() : 'image.jpg'}
          </p>
          <div className="d-flex justify-content-between align-items-center mt-3">
            <span className="badge" style={{ backgroundColor: "#e9ecef", color: "#495057", fontSize: "10px" }}>
              ID: {image.id}
            </span>
            <span className="badge" style={{ backgroundColor: "#007bff", color: "white", fontSize: "10px" }}>
              {new Date(image.created_at).toLocaleDateString()}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ImageCard;